import fetch from './api'
import {global} from './api.config'

let serverurl = ''
if (window.location.host === 'live.eoffcn.com') {
  serverurl = global.mall_online_url
} else {
  serverurl = global.mall_test_url
}
console.log(process.env.NODE_ENV)
// 获取回放地址和房间名称
const GETVODINFO = params => {
  return fetch({
    url: '/user/on_demand',
    // url: 'static/js/mock.js',
    method: 'post',
    // method: 'get',
    params: params
  })
}

const GETROOM = params => {
  return fetch({
    url: '/get_room',
    method: 'GET',
    params: params
  })
}

// 抽奖列表
const LIVEDRAWLIST = params => {
  return fetch({
    url: serverurl + '/drawTeacher/liveDrawList',
    method: 'post',
    data: params
  })
}

// 终止抽奖
const DRAWSTOP = params => {
  return fetch({
    url: serverurl + '/drawTeacher/stop',
    method: 'post',
    data: params
  })
}

// 删除抽奖
const DRAWDEL = params => {
  return fetch({
    url: serverurl + '/drawTeacher/del',
    method: 'post',
    data: params
  })
}

// 开奖
const DRAWEXEC = params => {
  return fetch({
    url: serverurl + '/drawTeacher/exec',
    method: 'post',
    data: params
  })
}

// 发起抽奖
const DRAWSTART = params => {
  return fetch({
    url: serverurl + '/drawTeacher/start',
    method: 'post',
    data: params
  })
}

// 中奖名单
const GETWINNINGPRIZERECORDSDETAIL = params => {
  return fetch({
    url: serverurl + '/drawTeacher/getWinningPrizeRecordsDetail',
    method: 'post',
    data: params
  })
}

// 创建抽奖
const LIVEDRAWEDIT = params => {
  return fetch({
    url: serverurl + '/drawTeacher/liveDrawEdit',
    method: 'post',
    data: params
  })
}

// 校验商品id
const GOODSINFO = params => {
  return fetch({
    url: serverurl + '/drawTeacher/goodsInfo',
    method: 'post',
    data: params
  })
}

// 校验货品编码
const CARGOINFO = params => {
  return fetch({
    url: serverurl + '/drawTeacher/cargoInfo',
    method: 'post',
    data: params
  })
}

// 校验商品id
const COUPONINFO = params => {
  return fetch({
    url: serverurl + '/drawTeacher/couponInfo',
    method: 'post',
    data: params
  })
}

// 获取学习平台
const STUDYPLATFORMS = params => {
  return fetch({
    url: serverurl + '/drawTeacher/studyPlatforms',
    method: 'post',
    data: params
  })
}

// 获取保存的抽奖
const DRAWDETAIL = params => {
  return fetch({
    url: serverurl + '/drawTeacher/detail',
    method: 'post',
    data: params
  })
}

// 导出中奖名单
const EXPORTDRAWRESULT = params => {
  return fetch({
    url: serverurl + '/drawTeacher/exportDrawResult',
    method: 'post',
    data: params
  })
}

// 获取当前直播间抽奖详情
const SDRAWDETAIL = params => {
  return fetch({
    setBaseUrl: 'mallDomain',
    setHeader: true,
    url: '/drawStudent/detail',
    method: 'post',
    data: params
  })
}

// 根据手机号批量获取学员信息
const GETSSOINFO = params => {
  return fetch({
    setHeader: true,
    url: serverurl + '/drawTeacher/batchGetUserSsoInfo',
    method: 'post',
    data: params
  })
}

export default {
  GETVODINFO,
  GETROOM,
  LIVEDRAWLIST,
  DRAWSTOP,
  DRAWDEL,
  DRAWEXEC,
  DRAWSTART,
  GETWINNINGPRIZERECORDSDETAIL,
  LIVEDRAWEDIT,
  GOODSINFO,
  CARGOINFO,
  COUPONINFO,
  STUDYPLATFORMS,
  DRAWDETAIL,
  EXPORTDRAWRESULT,
  SDRAWDETAIL,
  GETSSOINFO
}



// WEBPACK FOOTER //
// ./src/common/api/interface-teacher.js